import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { schemaSelector, isLoadingSelector, showSampleSelector } from '../../../../redux/selectors'
import SurveyResponseContainer from './SurveyResponseContainer'
import CircularProgress from '@material-ui/core/CircularProgress'
import SurveyResponseSample from './SurveyResponseSample'
import { makeStyles } from '@material-ui/styles'
import { Container, Grid } from '@material-ui/core';
import EmptySurvey from './EmptySurvey'

const useStyles = makeStyles((theme) => ({
	gridRoot: {
		padding: '1rem 0 3rem 0',
		height: '100%',
		minHeight: '600px'
	},
}))

const SurveyResponse = ({ schema, isLoading, showSample, showEmptyChart }) => {
	const classes = useStyles()
	return (
		<Grid data-testid="survey-response" style={{ backgroundColor: '#11121C' }}>
             <Container maxWidth="lg" style={{ paddingBottom: '61px' }}>
				<Grid container alignItems="center" justify="center" >
					<Grid
						item xs={12}
						className={classes.gridRoot}>
						{isLoading && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '100px 0' }}><CircularProgress data-testid="circular-progress" /></div>}
						{!isLoading && schema && <SurveyResponseContainer data-testid="survey-response-container" schema={schema} />}
						{showSample && !showEmptyChart && <SurveyResponseSample data-testid="survey-response-sample"/>}
						{showSample && showEmptyChart && <EmptySurvey data-testid="survey-response-empty"/>}
					</Grid>
				</Grid>
			</Container>
		</Grid>
	)
}

const mapStateToProps = (state, ownProps) => ({
	schema: schemaSelector(state),
	isLoading: isLoadingSelector(state),
	showSample: showSampleSelector(state),
})

const mapDispatchToProps = (dispatch, ownProps) => ({})

const enhance = compose(connect(mapStateToProps, mapDispatchToProps))

export default enhance(SurveyResponse)
